/**
 * Pure zoom→display-mode logic for the Parcel Map tab. Below the parcel
 * threshold we show a flat parcel-coverage choropleth (states, then counties);
 * at/above it we drop the choropleth and fetch individual parcel footprints in
 * the viewport. Kept Mapbox-free so it can be unit-tested directly.
 */

export type ParcelMapMode = 'states' | 'counties' | 'parcels';

/** Zoom at/above which we render individual parcels instead of the choropleth. */
export const PARCEL_ZOOM_THRESHOLD = 14;

/** Zoom at/above which the choropleth swaps state shading for county shading. */
export const COUNTY_ZOOM_THRESHOLD = 6;

export function parcelMapMode(zoom: number): ParcelMapMode {
  if (zoom >= PARCEL_ZOOM_THRESHOLD) return 'parcels';
  if (zoom >= COUNTY_ZOOM_THRESHOLD) return 'counties';
  return 'states';
}

/** Which Mapbox layers should be visible for a given mode. */
export function layerVisibility(mode: ParcelMapMode): {
  states: boolean;
  counties: boolean;
  parcels: boolean;
} {
  return {
    states: mode === 'states',
    counties: mode === 'counties',
    parcels: mode === 'parcels',
  };
}
